import React, { FC } from 'react'
import { When } from 'react-if'
import { LinkButton } from '@/atoms/Button'
import { InternalLink } from '@/atoms/InternalLink'
import { PaddedContainer } from '@/atoms/PaddedContainer'
import { Display, LabelLG, ParagraphLG } from '@/atoms/Text'
import { PIFPosters } from '@/molecules/PIFPosters/PIFPosters'
import { Project } from '@/services/ProjectsService'
import { useUser } from '@/services/UserService'
import { useLoginUrl } from '@/utils/auth-utils'
import { Translate, useTranslate } from '@/utils/translate/translate-client'

interface GetStartedProps {
  projects?: Project[]
}

export const GetStarted: FC<GetStartedProps> = ({ projects = [] }) => {
  const { t } = useTranslate('pif')
  const { isLoggedIn } = useUser()
  const { loginUrl, trackLoginStarted } = useLoginUrl()

  return (
    <div id="pif-getting-started" className="bg-black bg-cover bg-no-repeat px-12 pt-20">
      <div className="h-full w-full bg-black">
        <PaddedContainer>
          <Display
            as={(p) => <h2 {...p} />}
            weight="bold"
            className="photon-heading-md sm:photon-heading-lg md:photon-heading-xl lg:photon-display mb-4"
          >
            {t('getStartedNow', 'Get started now')}
          </Display>
          <div className="mt-6 lg:max-w-xl">
            <ParagraphLG className="photon-paragraph-sm md:photon-paragraph-md lg:photon-paragraph-lg core-gray-200 font-[350]">
              <Translate i18nKey="nowIsPerfectTimeGetInvolved" t={t}>
                Now’s the perfect time to get involved. Below are the stories that are waiting for your Pay it Forward
                support. If you don’t have an Angel account yet,{' '}
                <InternalLink
                  className="cursor-pointer font-bold underline"
                  href={loginUrl}
                  onClick={() => trackLoginStarted('pif-getting-started')}
                >
                  simply create one
                </InternalLink>{' '}
                to start making an impact today.
              </Translate>
            </ParagraphLG>
            <When condition={!isLoggedIn}>
              <LinkButton
                onClick={() => trackLoginStarted('pif-getting-started')}
                href={loginUrl}
                className="mt-8 min-h-[64px] w-fit justify-center border-0 px-6 py-[14px] font-[375] !text-white md:px-7 md:py-[17px] lg:max-w-fit"
                variant="core-gray-700"
              >
                <LabelLG weight="bold">{t('createAnAccount', 'Create an Account')}</LabelLG>
              </LinkButton>
            </When>
          </div>
          <PIFPosters projects={projects} />
        </PaddedContainer>
      </div>
    </div>
  )
}
